import React from "react"
import old_school_logo from "../Assets/old_school_logo.png";

const Footer = () => {
    return (
        <div style={{ fontFamily: "'Inter', sans-serif" }}>
            <div className="flex gap-12 flex-col px-4 md:px-10 lg:px-16 py-14 md:flex-row bg-[#F6F5F1] justify-between">
                <div>
                    <img className="w-16" src={old_school_logo} alt="School logo" />
                </div>

                <div>
                    <h3 className="text-[#12213D] mb-4" style={{ fontFamily: "'Fraunces', serif", fontWeight: 500 }}>
                        Our courses
                    </h3>
                    <ul className="flex flex-col gap-2 text-[#5B6472] text-sm">
                        <li>Community Health</li>
                        <li>Medical Laboratory Science</li>
                        <li>Pharmacy</li>
                        <li>Dispensary & Optometry Tech (DOT)</li>
                    </ul>
                </div>

                <div>
                    <h3 className="text-[#12213D] mb-4" style={{ fontFamily: "'Fraunces', serif", fontWeight: 500 }}>
                        Contact us
                    </h3>
                    <ul className="flex flex-col gap-2 text-[#5B6472] text-sm">
                        <li>Bewo, Bekwarra</li>
                        <li>Cross River, Nigeria</li>
                        <li>+234 818 432 7668</li>
                        <li>+234 802 786 0306</li>
                        <li>ocohstech@gmail.com</li>
                    </ul>
                </div>
            </div>

            <div className="flex flex-col md:flex-row gap-2 md:gap-0 justify-between py-4 px-4 md:px-10 lg:px-16 text-xs bg-[#12213D] text-[#C7CCDA]">
                <div>Privacy policy</div>
                <div>©2026 www.ocohstech.com</div>
            </div>
        </div>
    )
}

export default Footer;